(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/single-row.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/single-row.js'); 
'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const {
  focusElement
} = svs.numbergames.core.utils.ui;
const extraNumberNames = {
  EUROJACKPOT: 'stjärnnummer',
  VIKINGLOTTO: 'vikingnummer'
};
const getRowLabel = _ref => {
  let {
    rowIndex,
    numbers,
    numbersExtra,
    isEmpty,
    isActive,
    productId
  } = _ref;
  let text = "Rad ".concat(rowIndex, ", ");
  if (isEmpty) {
    text += 'tom rad';
  } else {
    text += "".concat(numbers.length, " nummer");
    if (numbersExtra) {
      text += ", ".concat(numbersExtra.length, " ").concat(extraNumberNames[productId]);
    }
  }
  if (isActive) text += ', aktiv rad';
  return text;
};
const getNumbersLabel = _ref2 => {
  let {
    numbers,
    numbersExtra,
    isEmpty,
    productId
  } = _ref2;
  if (isEmpty) return 'Inga valda nummer';
  let text = "Nummer ".concat(numbers.toArray().join(', '));
  const extraNumberType = extraNumberNames[productId];
  if (extraNumberType) {
    text += ", ".concat(extraNumberType, " ").concat(numbersExtra.toArray().join(', '));
  }
  return text;
};
svs.numbergames.game.views.SingleRow = Marionette.View.extend({
  viewOptions: ['ballRowBranding', 'ballRowSize', 'rowIndex', 'multipliedRowPrice'],
  ballRowBranding: 'Default',
  ballRowSize: 200,
  isKeno: false,
  multipliedRowPrice: 0,
  className: 'numbergames-single-row',
  ui: {
    row: '.ball-row-inner',
    numbers: '.ball-row-numbers',
    clearRow: '.ball-row-btn-clear'
  },
  triggers: {
    'click @ui.row': 'rowClicked',
    'click @ui.clearRow': 'rowClear',
    'keydown @ui.row': {
      event: 'rowKeydown',
      preventDefault: false,
      stopPropagation: false
    },
    'keydown @ui.numbers': {
      event: 'numbersKeydown',
      preventDefault: false,
      stopPropagation: false
    },
    'keydown @ui.clearRow': {
      event: 'clearRowKeydown',
      preventDefault: false,
      stopPropagation: false
    }
  },
  modelEvents: {
    'number:added': 'addNumber',
    'huxflux:added': 'addHuxfluxedNumber',
    'number:removed huxflux:removed': 'removeNumber',
    'number:changed': 'changeNumber',
    'numbers:removed:all': 'clearAll',
    'change:hasKungKeno': 'changeHasKungKeno',
    'change:level': 'changeLevel',
    'change:isActive': 'changeIsActive',
    'change:isValid': 'changedIsValid',
    'change:isEmpty': 'changedIsEmpty',
    'change:board': 'updateNumbersLabels'
  },
  initialize() {
    this.mergeOptions(this.options, this.viewOptions);
    this.isKeno = svs.numbergames.productMapping.isKeno(this.model.get('productId'));
    const options = {
      size: this.ballRowSize,
      isValid: this.model.get('isValid'),
      isEmpty: this.model.get('isEmpty'),
      isActive: this.model.get('isActive'),
      kungKeno: this.model.get('hasKungKeno'),
      numbers: this.model.get('level'),
      useGrid: true
    };
    if (this.isKeno) options.winPlan = new svs.tur.ball.row.extensions.WinPlan(this.getWinPlanText());
    this.row = new svs.tur.ball.row.play[this.ballRowBranding](options);
    if (!this.model.get('isEmpty')) {
      const {
        numbers,
        numbersExtra
      } = this.model.getNumberListArrays();
      if (numbers.length) {
        numbers.forEach((to, index) => {
          this.row.update({
            index,
            to
          });
        });
      }
      if (numbersExtra && numbersExtra.length) {
        numbersExtra.forEach((to, index) => {
          this.row.update({
            index,
            to,
            extraNumber: true
          });
        });
      }
    }
  },
  template(_ref3) {
    let {
      row
    } = _ref3;
    return row.render();
  },
  templateContext() {
    return {
      row: this.row
    };
  },
  onAttach() {
    this.updateNumbersLabels();
    this.getUI('row').attr('tabindex', -1);
    this.getUI('numbers').attr('tabindex', -1);
    this.getUI('clearRow').attr({
      tabindex: -1,
      'aria-label': "Ta bort rad ".concat(this.rowIndex)
    });
  },
  updateNumbersLabels() {
    this.getUI('row').attr('aria-label', getRowLabel(_objectSpread({
      rowIndex: this.rowIndex
    }, this.model.attributes)));
    this.getUI('numbers').attr('aria-label', getNumbersLabel(this.model.attributes));
  },
  getWinPlanText() {
    let title = '&nbsp;';
    let description = '';
    const level = this.model.get('level');
    if (level && this.model.get('isValid')) {
      const {
        getLevelWinPlanTopWin
      } = svs.numbergames.rules.utils.keno_winplan;
      const hasKungKeno = this.model.get('hasKungKeno');
      const maxWin = getLevelWinPlanTopWin({
        level,
        rowPrice: this.multipliedRowPrice,
        hasKungKeno
      });
      title = "Keno ".concat(level);
      description = "- Toppvinst ".concat(svs.utils.format.Currency(maxWin), " kr");
    }
    return {
      title,
      description
    };
  },
  onUpdateWinPlan(multipliedRowPrice) {
    if (!this.isKeno) return;
    this.row.row.winPlan.update(this.getWinPlanText(multipliedRowPrice));
  },
  onUpdateMultipliedRowPrice(multipliedRowPrice) {
    this.multipliedRowPrice = multipliedRowPrice;
    if (this.model.get('isValid')) {
      this.triggerMethod('updateWinPlan');
    }
  },
  addNumber(board, _ref4) {
    let {
      number,
      index,
      isExtra
    } = _ref4;
    this.row.add({
      number,
      index,
      extraNumber: isExtra
    });
  },
  addHuxfluxedNumber(board, _ref5) {
    let {
      number,
      index,
      isExtra
    } = _ref5;
    this.row.addHuxfluxed({
      number,
      index,
      extraNumber: isExtra
    });
  },
  removeNumber(board, _ref6) {
    let {
      number,
      index,
      isExtra
    } = _ref6;
    this.row.remove({
      number,
      index,
      extraNumber: isExtra
    });
  },
  changeNumber(board, _ref7) {
    let {
      index,
      number,
      isExtra
    } = _ref7;
    this.row.update({
      index,
      to: number,
      extraNumber: isExtra
    });
  },
  clearAll() {
    this.row.clearAll();
  },
  changeHasKungKeno(model, hasKungKeno) {
    this.row.toggleKungKeno(hasKungKeno);
    this.triggerMethod('updateWinPlan');
  },
  changeLevel(model, level) {
    this.row.setKenoLevel && this.row.setKenoLevel(level);
  },
  changedIsValid(model, isValid) {
    this.row.valid = isValid;
    this.triggerMethod('updateWinPlan');
  },
  changeIsActive(model, isActive) {
    this.row.active = isActive;
    this.getUI('row').attr('aria-label', getRowLabel(_objectSpread({
      rowIndex: this.rowIndex
    }, this.model.attributes)));
    if (!isActive) {
      this.getUI('clearRow').attr('tabindex', -1);
      this.destroyIfShouldBeRemoved();
    }
  },
  changedIsEmpty(model, isEmpty) {
    this.row.empty = isEmpty;
    this.destroyIfShouldBeRemoved();
  },
  destroyIfShouldBeRemoved() {
    if (svs.core.detect.formfactor.mobile() && !this.model.get('isActive') && this.model.get('isEmpty')) {
      this.model.destroy();
    }
  },
  onRowClear() {
    this.model.clear();
  },
  onRowClicked() {
    this.model.set({
      isActive: true
    });
  },
  onHuxfluxStarted() {
    this.row.hideClearButton();
  },
  onHuxfluxEnded() {
    this.row.showClearButton();
  },
  onKeyboardClearRow() {
    this.triggerMethod('rowClear');
    this.triggerMethod('focus');
  },
  onKeyboardActivateRow() {
    this.triggerMethod('rowClicked');
    if (this.getUI('row').attr('tabindex') === 0) {
      this.getUI('clearRow').attr('tabindex', 0);
    }
  },
  onFocus() {
    focusElement(this.getUI('row'));
  },
  onFocusNumbers() {
    focusElement(this.getUI('numbers'));
  },
  onFocusClearButton() {
    focusElement(this.getUI('clearRow'));
  },
  onToggleKeyboardNavigation(tabindex) {
    this.getUI('row').attr('tabindex', tabindex);
    if (tabindex === 0 && this.model.get('isActive')) {
      focusElement(this.getUI('row'));
      this.getUI('clearRow').attr('tabindex', 0);
    }
  }
});
 })(window);